import { gql } from '@apollo/client';

// ===== Analytics workflows =====
// A workflow stores one graph: { nodes: [{ id, type, params, position }],
// edges: [{ id, source, target }] }. Editing saves the whole graph; running
// queues a job that stores per-node results which the page polls for.

import { WORKFLOW_FIELDS } from './analytics_projects';

export const ANALYTICS_WORKFLOWS = gql`
  query AnalyticsWorkflows($projectId: ID) {
    analyticsWorkflows(projectId: $projectId) {
      ${WORKFLOW_FIELDS}
      graph
      result
    }
  }
`;

export const CREATE_ANALYTICS_WORKFLOW = gql`
  mutation CreateAnalyticsWorkflow($input: CreateAnalyticsWorkflowInput!) {
    createAnalyticsWorkflow(input: $input) {
      ${WORKFLOW_FIELDS}
      graph
    }
  }
`;

export const UPDATE_ANALYTICS_WORKFLOW = gql`
  mutation UpdateAnalyticsWorkflow($input: UpdateAnalyticsWorkflowInput!) {
    updateAnalyticsWorkflow(input: $input) {
      ${WORKFLOW_FIELDS}
      graph
      result
    }
  }
`;

export const DELETE_ANALYTICS_WORKFLOW = gql`
  mutation DeleteAnalyticsWorkflow($input: DeleteAnalyticsWorkflowInput!) {
    deleteAnalyticsWorkflow(input: $input) {
      id
    }
  }
`;

export const RUN_ANALYTICS_WORKFLOW = gql`
  mutation RunAnalyticsWorkflow($input: RunAnalyticsWorkflowInput!) {
    runAnalyticsWorkflow(input: $input) {
      id
      status
      error
    }
  }
`;

export const ANALYTICS_EXPORT = gql`
  mutation AnalyticsExport($input: AnalyticsExportInput!) {
    analyticsExport(input: $input) {
      filename
      contentType
      encoding
      content
    }
  }
`;
